import { Component, NgZone, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { openTSDialog } from 'src/app/helpers/methods';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { MatDialog } from '@angular/material/dialog';
import { SubscriptionService } from '@app-services/subscription/subscription.service';
import { openILITESignUpDialog } from 'src/app/helpers/methods';
import { apisDataCacheKeys } from '@app-constants/app.constants';
import { TestlistService } from '@app-services/test/testlist.service';
@Component({
  selector: 'app-paynowregistration',
  templateUrl: './paynowregistration.component.html',
  styleUrls: ['./paynowregistration.component.css']
})
export class PaynowregistrationComponent implements OnInit {
  public options: any = {
    key: environment.razorkey,
    name: '',
    description: 'Subscription',
    amount: 249, // razorpay takes amount in paisa
    prefill: {
      name: '',
      email: '', // add your email id
      "contact": ""
    },
    notes: {},
    theme: {
      color: '#3880FF'
    },
    "order_id": "",
    handler: this.paymentHandler.bind(this),
    modal: {
      ondismiss: (() => {
        this.zone.run(() => {
          let body = {
            "amount": this.PackageDetails?.packageSubscriptionDto?.[0].amount,
            "creationDate": new Date().toISOString(),
            "status": "aborted",
            "userId": this.subscriptionbillingUtility.userDetails?.userId,
            "userOrderId":  this.subscriptionbillingUtility.orderId
          }
          this.SubscriptionService.paymentABortedbyUser(body).subscribe((resp) => {

          })
          // add current page routing if payment fails
          this.router.navigate(['/congratulations'],{...this.routeparam,status:'fail'})
        })
      })
    }
  };
  subscriptionbillingUtility: any ={

  };
  rzp: any;
  PackageDetails: any;
  routeparam:any; 
  openTSDialog = openTSDialog;
  openSignUpDialog = openILITESignUpDialog;
  trackierSource: any = "https://marketing.infinitylearn.com/pixel?av=612df4c302535a0b13372bab&sub1=mobile&sub2=email&sub3=first_name&sub4=last_name&sub5=grade&sub6=exam";
  constructor(public router: Router, public spinner: NgxSpinnerService, private zone: NgZone, public SubscriptionService: SubscriptionService,private gAnalytics: GAnalyticsService,private dialog: MatDialog, private testListService: TestlistService) { 
    this.routeparam = this.router.getCurrentNavigation()?.extras?.state
    console.log('routeparam: ', this.routeparam);
    
  }
  ngOnInit(): void {
    this.initFun(null);
  }
  initFun(cb: any) {
    if(this.routeparam?.detailsEntered) {
      const routeparam = this.routeparam;
    this.trackierSource = `https://marketing.infinitylearn.com/pixel?av=612df4c302535a0b13372bab&sub1=${routeparam?.phone}&sub2=${routeparam?.email}&sub3=${routeparam?.firstname}&sub4=${routeparam?.lastname}&sub5=${routeparam?.grade}&sub6=${routeparam?.exam}`; 
    var year = 0;
    switch (this.routeparam?.grade) {
      case '11th':
        year = 2023;
        break;
        case '12th':
        year = 2022;
        break;
        case '13th':
        year = 2022;
        break;
        case '10th':
        year = 2024;
        break;
        case '9th':
        year = 2025;
        break;
    }
    let data = {
      year :year,
      examName:this.routeparam?.exam,
      packageName:this.routeparam?.grade?.substring(0,2)
    }
    this.getPackageDetails(data, cb)
    }
  }
  razorPayWindowPrestep() {
    
    if(this.routeparam?.detailsEntered) {
          
      this.getRuleIDAndOpenRPWindow(this.routeparam);
        
    } else {
      const dialogRef = this.openTSDialog({
        message: 'One more step and you are all set',
          source: 'ILITE',
          countryCode: "+91",
          hiddenFields: {hallticket: true},
          needPayment: true, 
          ILITE: true,
          ILITEDirect: true
      })
      dialogRef.afterClosed().subscribe((value) => {
        if (value) {
          //this.spinner.hide();
          this.routeparam = value;
          this.initFun(() => {this.getRuleIDAndOpenRPWindow(value)});    
        }
      });
    }
  }
  getRuleIDAndOpenRPWindow(routeparam) {
    const tsBody = {
      "examtype": [
        routeparam?.examtype
      ],
      "coursetype": [
        routeparam?.exam
      ],
      "classes": [
        routeparam?.grade
      ]
    }
    this.spinner.show();  
    this.testListService.getPreviousAndPresentMockTests(tsBody).subscribe(async (overallTests: any) => {
      
      this.spinner.hide();
      let rule;
      if(overallTests?.length) {
        rule = overallTests[0];
      } else {
        //Vikas to handle, so that excel sheet can be shared?
      }
      this.razorPayWindow(routeparam, rule?._id);
    },  (error:any) => {                                     // on error
      this.spinner.show();
      alert(error?.error?.message || error?.error?.text || 'Server error');
    });      
  }
  razorPayWindow(routeparam, ruleID) {

    let user: any = localStorage.getItem(apisDataCacheKeys.userDetails);
    // var stateName = this.subscriptionbillingUtility.states.find((val) => val.abbreviation == this.subscriptionbillingUtility.selectedState)
    user = localStorage.getItem(apisDataCacheKeys.userDetails) ? JSON.parse(user) : {}
    this.subscriptionbillingUtility.userDetails = user;

    var object = {
      "amountAfterDiscount":this.PackageDetails?.packageSubscriptionDto?.[0].amount,
      "billingAddress": {
        "address": '',//this.subscriptionbillingUtility.billingAddress ?? '',
        "email": routeparam?.email ?? '',
        "firstName": routeparam?.firstName ? routeparam?.firstName : routeparam?.firstname ? routeparam?.firstname : '',
        "lastName": routeparam?.lastName ? routeparam?.lastName : routeparam?.lastname ? routeparam?.lastname :'',
        "phone": routeparam?.phone ?? '',
        "statecode": routeparam.selectedState?.abbreviation,
        "zipcode": '',//,this.subscriptionbillingUtility.selectedPin,
        "stateName": routeparam.selectedState?.name,
      },
      "discountAmount": 0,
      "discountCode": this.subscriptionbillingUtility.discountCode ? this.subscriptionbillingUtility.discountCode : null,
      "notes": "",
      "orderAmount": this.PackageDetails?.packageSubscriptionDto?.[0].amount,
      "packageSubscriptions": [
        {
          "id": this.PackageDetails?.packageSubscriptionDto?.[0].id,
        }
      ],
      "isdCode":   '',
      "phone": routeparam?.phone ?? '',
      "paymentGatewayCode": "RAZORPAY",
      "userId": this.subscriptionbillingUtility.userDetails?.userId
    }
    this.SubscriptionService.userorders(object).subscribe((resp: any) => {
      this.subscriptionbillingUtility.generatedOrderDetails = resp;
      this.options.order_id = resp?.gatewayOrderId;
      this.subscriptionbillingUtility.orderId = resp?.orderId;
      this.options.amount = object?.amountAfterDiscount * 100;//amountAfterDiscount for razor pay
      this.options.name = this.subscriptionbillingUtility.userDetails.firstName + ' ' + this.subscriptionbillingUtility.userDetails.lastName;
      this.options.prefill.name = this.options.name;
      this.options.prefill.email = this.subscriptionbillingUtility.userDetails.email;
      this.options.prefill.contact = this.subscriptionbillingUtility.mobileNumber ? this.subscriptionbillingUtility.mobileNumber :routeparam?.phone ;
      this.createOrderid()
    })
  }
  createOrderid() {
    this.rzp = new this.SubscriptionService.nativeWindow['Razorpay'](this.options);
    this.rzp.open();
    this.rzp.on('payment.failed', (response: any) => {
    });
  }
  paymentHandler(res: any) {
    this.zone.run(() => {
      if (res?.razorpay_signature) {
        var obj = {
          "gatewayCode": "RAZORPAY",
          "paymentMode": "ONLINE",
          "razorpayOrderId": res?.razorpay_order_id,
          "razorpayPaymentId": res?.razorpay_payment_id,
          "razorpaySignature": res?.razorpay_signature,
          "userOrderId": this.subscriptionbillingUtility.orderId
        }
        this.SubscriptionService.userPayment(obj).subscribe((resp: any) => {
          /* on Payment success*/
          //if(this.data?.ILITE) {
      
            let user = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails));
            this.gAnalytics.sendEvent(
              `Payment Successful For Exam`, 
              `ILITE_page`, 
              `Payment Successful For Exam`,  
              `ILITE_page`,  
              {
                'event': 'Payment Successful For Exam',
                'Phone Number': user.phone,
                'First Name': user.firstName,
                'Last Name': user.lastName,
                'City': '',
                'Email ID': user.email,
                'Test Name': "ILITE test",
                'User Id': user.userId,
                'Current_Grade': `${user?.grade.name}`,
                'Select_Exam': `${user?.exams && user?.exams[0].name}`,
                'Whatsapp_Consent': user?.whatsappConsent,
                'Amount': 249, // Datatype should be number
                'Order_Id': this.subscriptionbillingUtility?.orderId
              }
            );
          //}
          this.router.navigate(['/congratulations'],{state:{...this.routeparam, status:'success',...{payment:resp}}})
        })
      }
      // add API call here
    });
  }
  getPackageDetails(packageName: any,cb: any){
    var param ={
      examName: packageName?.examName?.replaceAll(" ", "")?.toUpperCase(),
      year:packageName?.year,
      producttype:'assessment,liveclasses',
      pageUrl: "studentPortal_Subscriptions",
    }
    let grade = this.routeparam?.grade?.split('th')?.[0];
      this.SubscriptionService.totalexamTypePackages(param,grade).subscribe((res: any) => {
       var packageDEtail=  res.filter(x => x.productName === 'ILITE(Scholarship)')
       if( packageDEtail?.length > 1 ){
          var findPackagewithgrade = packageDEtail.find(val=>val.name.indexOf(packageName?.grade) !==-1)
          if(findPackagewithgrade){
            packageDEtail = [findPackagewithgrade]
          }else{
            packageDEtail = [packageDEtail?.[0]]
          }
       }
        this.PackageDetails = packageDEtail?.[0];
        if(cb) cb();
      })
  }
}
